import type { RootState } from 'store';
import type { FilterGroup } from 'types/userConfig/userConfig';
import { convertCustomFiltersToApiFilters } from 'utils/convert-filters-to-api';
import type { ChatScope, UnreadCountsRequest } from 'api/unread-counts';
import {
  SEND_FAILED_COUNT_IDS,
  buildSendFailedCountFiltersForScope,
} from 'utils/awaiting-customer-send-failed';
import type { ChatSidebarScopeTab } from 'utils/chat-sidebar-unified-statuses';

const ALL_SCOPES: ChatScope[] = ['mine', 'team', 'all'];

let correlationCounter = 0;
function nextCorrelationId(): string {
  correlationCounter += 1;
  return `uc-${correlationCounter}`;
}

/**
 * בונה את גוף הבקשה ל-getUnreadCounts מתוך ה-Redux state.
 */
export function buildUnreadCountsRequest(state: RootState): UnreadCountsRequest | null {
  const udid = state.user?.Udid;
  if (!udid) return null;

  const customViewsState = state.userConfig?.customViews ?? [];
  const visible = customViewsState.filter(
    (v) => !v.hiddenForApplicationUserUdids?.includes(udid),
  );

  const customViews = visible.map((view) => {
    const filters = convertCustomFiltersToApiFilters(view.filters as FilterGroup[], view.filtersLogic);
    return {
      viewId: String(view.id),
      filters,
      filtersLogic: view.filtersLogic ?? 'and',
    };
  });

  const scopes: ChatSidebarScopeTab[] = ['mine', 'team', 'all'];
  for (const scope of scopes) {
    customViews.push({
      viewId: SEND_FAILED_COUNT_IDS[scope],
      filters: buildSendFailedCountFiltersForScope(scope, udid),
      filtersLogic: 'and',
    });
  }

  return {
    currentUserUdid: udid,
    scopes: ALL_SCOPES,
    customViews,
    correlationId: nextCorrelationId(),
  };
}
